<bb-tabs></bb-tabs>
<bb-heading-container></bb-heading-container>
<bb-render-html [path]="path$ | async"></bb-render-html>
